import { render } from "./About.vue?vue&type=template&id=039c5b43"
const script = {}

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/About.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "039c5b43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('039c5b43', __exports__)) {
    console.log('reload')
    api.reload('039c5b43', __exports__)
  }
  
  module.hot.accept("./About.vue?vue&type=template&id=039c5b43", () => {
    console.log('re-render')
    api.rerender('039c5b43', render)
  })

}


export default __exports__